import { API_URL } from "../config/connect";

const getAuthHeaders = () => {
  const token = localStorage.getItem('google_id_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// ============================================
// 🔐 ADMIN ROUTES (Authentication Required)
// ============================================

// Promotion Packages - Admin
export const getPromotionPackages = async () => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/promotion-packages`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching promotion packages:', error);
    throw error;
  }
};

export const getPromotionPackageById = async (packageId) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/promotion-packages/${packageId}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching promotion package by ID:', error);
    throw error;
  }
};

export const createPromotionPackage = async (packageData) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/promotion-packages`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(packageData)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error creating promotion package:', error);
    throw error;
  }
};

export const updatePromotionPackage = async (packageId, packageData) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/promotion-packages/${packageId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(packageData)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error updating promotion package:', error);
    throw error;
  }
};

export const deletePromotionPackage = async (packageId) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/promotion-packages/${packageId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error deleting promotion package:', error);
    throw error;
  }
};

// Tariffs - Admin
export const getTariffs = async () => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/tariffs`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching tariffs:', error);
    throw error;
  }
};

export const getTariffById = async (tariffId) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/tariffs/${tariffId}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching tariff by ID:', error);
    throw error;
  }
};

export const createTariff = async (tariffData) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/tariffs`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(tariffData)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error creating tariff:', error);
    throw error;
  }
};

export const updateTariff = async (tariffId, tariffData) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/tariffs/${tariffId}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(tariffData)
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error updating tariff:', error);
    throw error;
  }
};

export const deleteTariff = async (tariffId) => {
  try {
    const response = await fetch(`${API_URL}/api/v1/admin/tariffs/${tariffId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }));
      throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error deleting tariff:', error);
    throw error;
  }
};

